import { useState, useContext, useEffect } from 'react';
import GlobalContext from '../../../../../context/global-context';
import TablaViewComprobante from './TablaViewComprobante';
import FilterControl from '../../../table/FilterControl';
import FilterDateControl from '../../../table/FilterDateControl';
import { OrganizationAPI } from '../../../../../api/organization.api';
import translations from '../../traslation/traslationMiContador.json';
import translationsM from '../../../ui/traslation/traslationAdministracion.json'
import ResizableModal from '../../ResizableModal';
import { Title } from '../../../ui'
import CustomButton from '../../CustomButton';

const ModalViewAdministracion = ({ openModal, setOpenModal, comprobanteId, validation, folio, numeroFolio }) => {
  const [totalDebe, setTotalDebe] = useState(0);
  const [totalHaber, setTotalHaber] = useState(0);
  const [data, setData] = useState(null); // Contendrá directamente los datos de la API
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { currentBusiness } = useContext(GlobalContext);
  const organizationAPI = new OrganizationAPI();
  const handleClose = () => setOpenModal(false);

  // Función para manejar la fecha sin alterar su valor
  const parseDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // Devuelve el original si no es válida
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    let active = true;
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        setData(null);
        const response = await organizationAPI.getComprobante({
          businessId: currentBusiness.id,
          comprobanteId,
        });
        if (!active) return;
        const fetchedData = { ...response?.data };
        if (!Array.isArray(fetchedData.data)) {
          throw new Error('Respuesta de comprobante sin asientos contables');
        }
        const obtenerAbreviatura = folio => {
          return translationsM.documentosContables[folio] || folio 
        }
        // Parsear la fecha sin cambiar su valor
        fetchedData.fecha = parseDate(fetchedData.fecha);
        fetchedData.descripcion = fetchedData.descripcion || `${obtenerAbreviatura(folio)|| ''}  ${numeroFolio || ''} ${fetchedData.razonSocial || ''}  ${fetchedData.rut || ''}`;
        setData(fetchedData)
        // Calcular totales
        const totalDebe = fetchedData.data.reduce((acc, libro) => acc + libro.debe, 0);
        const totalHaber = fetchedData.data.reduce((acc, libro) => acc + libro.haber, 0);

        setTotalDebe(totalDebe);
        setTotalHaber(totalHaber);
      } catch (error) {
        if (active) {
          setError('No se pudo cargar el comprobante. Cierra el modal e intenta nuevamente.');
        }
        console.error('Error al obtener los datos:', error);
      } finally {
        if (active) setLoading(false);
      }
    };

    if (openModal && comprobanteId && currentBusiness?.id) fetchData();
    return () => { active = false; };
  }, [openModal, comprobanteId, currentBusiness?.id]);

  if (!openModal) return null;
  return (
    <ResizableModal open={openModal} onClose={handleClose}
    footer={<>
      <CustomButton  className='rounded-full' color='primary' title='CANCELAR' onClick={handleClose} />
    </>}
    >
          {loading ? (
            <p role='status' className='p-6'>Cargando comprobante...</p>
          ) : error ? (
            <p role='alert' className='p-6 text-red-600'>{error}</p>
          ) : data ? <>
          <div className='flex justify-between items-center p-4'>
            <Title className='text-3xl font-sans'>
              {translations.comprobantes.comprobanteView} - {data.comprobanteNumero || '-'}
            </Title>
          </div>

          <div className='p-4 mt-2 bg-white rounded-lg'>
          <div className='flex flex-wrap items-center gap-4 mb-6 mt-4'>
            <FilterDateControl label='Fecha' value={data.fecha || ''} disabled />
            <FilterControl
              label='Tipo de Comprobante'
              value={data.tipoComprobante || ''}
              options={[{ label: 'Traspaso', value: 'traspaso' }]}
              disabled
            />
          </div>

          {/* Glosa */}
          <div className='mb-6 '>
            <label className='block text-sm font-medium text-gray-700'>
              {translations.comprobantes.glosa}
            </label>
            <textarea
              className='rounded-3xl mt-1 w-full border-gray-300 shadow-sm p-3'
              rows='1'
              value={data.descripcion || ''}
              disabled
            ></textarea>
          </div>

          {/* Tabla View Comprobante */}
          <TablaViewComprobante
            setTotalDebe={setTotalDebe}
            setTotalHaber={setTotalHaber}
            totalDebe={totalDebe}
            totalHaber={totalHaber}
            initialData={data.data || []} // Libros directamente de la API
            context='view'
            validation={validation}
            descripcion={data.descripcion}
          />

          {/* Botón de cierre 
          <div className='flex justify-end mt-6'>
            <CustomButton className='rounded-full' color='primary' title='Cerrar' onClick={handleClose} />
          </div>*/}
          </div>
          </> : null}
    </ResizableModal>
  );
};

export default ModalViewAdministracion;
